// utils/api.ts
import { AxiosError } from "axios";

export function reportApiError(error: AxiosError): void {
  if (error.response) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
  } else if (error.request) {
    console.log(error.request);
  } else {
    console.log('Error', error.message);
  }
}